import {stepsConfig} from "../config/steps";

// Initialize Google Analytics
export const initGA = (measurementId) => {
    // Load GA script
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    function gtag() {
        window.dataLayer.push(arguments);
    }

    gtag("js", new Date());
    gtag("config", measurementId, {
        send_page_view: false, // Disable automatic page views
    });

    window.gtag = gtag;
};

// Track step view
export const trackStepView = (stepIndex) => {
    const step = stepsConfig.steps[stepIndex];
    if (!step) return;

    window.gtag?.("event", `step_${step.id}_view`);
};

// Track step completion
export const trackStepComplete = (stepIndex, value) => {
    const step = stepsConfig.steps[stepIndex];
    if (!step) return;

    window.gtag?.("event", `step_${step.id}_complete`, {
        value,
    });
};

// Track funnel abandonment
export const trackFunnelAbandonment = (stepIndex) => {
    const step = stepsConfig.steps[stepIndex];
    if (!step) return;

    window.gtag?.("event", `step_${step.id}_abandonment`);
};

// Track payment
export const trackPayment = (planId, amount) => {
    window.gtag?.("event", "purchase", {
        currency: "USD",
        value: amount,
        items: [
            {
                item_id: planId,
                item_name: `${planId} Plan`,
                price: amount,
            },
        ],
    });
};
